import {
  UPDATECURRENCYMASTERLIST_SUCCESS,
  UPDATECURRENCYMASTERLIST_FAILED,
  RESET_UPDATECURRENCYMASTERLIST,
  LOADING_UPDATECURRENCYMASTERLIST,
  NETWORK_ERROR_UPDATECURRENCYMASTERLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateCurrencyMasterList = () => {
  return { type: RESET_UPDATECURRENCYMASTERLIST };
};

const updateCurrencyMasterList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATECURRENCYMASTERLIST });
    await partnerServices
      .post("updateCurrencyMasterList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(updateCurrencyMasterListSuccess(res.data));
            break;
          default:
            dispatch(updateCurrencyMasterListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_UPDATECURRENCYMASTERLIST,
          payload: err,
        });
      });
  };
function updateCurrencyMasterListSuccess(data) {
  return {
    type: UPDATECURRENCYMASTERLIST_SUCCESS,
    payload: data,
  };
}
function updateCurrencyMasterListFailed(data) {
  return {
    type: UPDATECURRENCYMASTERLIST_FAILED,
    payload: data,
  };
}

export { resetUpdateCurrencyMasterList, updateCurrencyMasterList };
